import { isHttpUrl } from '../utils/isHttpUrl';

export const COMPLETION_REDIRECT_URL_MAX = 2048;

// why: the URL is navigated to (window.location.assign) or handed to an embedding host, so only
// why: absolute http(s) URLs are allowed — `javascript:` / `data:` would execute in our origin.
export const isAllowedCompletionRedirectUrl = (value: unknown): value is string => {
  if (typeof value !== 'string' || value.length === 0 || value.length > COMPLETION_REDIRECT_URL_MAX) return false;
  return isHttpUrl(value);
};

type MissionRedirectSource = { completionRedirectUrl?: string | null } | null | undefined;
type BrandRedirectSource = { defaultCompletionRedirectUrl?: string | null } | null | undefined;

// why: returns the parsed URL's href, never the raw input — `https:example.com/x` passes `new URL()` but
// why: `location.assign` would resolve the raw string relative to the current page.
const normalizeCompletionRedirectUrl = (value: unknown): string | null =>
  isAllowedCompletionRedirectUrl(value) ? new URL(value).href : null;

// why: mission override → brand default → null (null = keep the existing in-app completion flow).
// why: re-validates on read so a legacy/hand-edited row can never yield an unsafe navigation target.
export const resolveCompletionRedirectUrl = (
  mission: MissionRedirectSource,
  brandConfig: BrandRedirectSource,
): string | null =>
  normalizeCompletionRedirectUrl(mission?.completionRedirectUrl) ??
  normalizeCompletionRedirectUrl(brandConfig?.defaultCompletionRedirectUrl);
